import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type DepartmentState = {
  items: Department[];
  detail: Department | null;
};

export const departmentInitialState: DepartmentState = { items: [], detail: null };

const slice = createSlice({
  name: 'department',
  initialState: departmentInitialState,
  reducers: {
    setDepartments(state, action: PayloadAction<Department[]>) { state.items = action.payload; },
    setDepartmentDetail(state, action: PayloadAction<Department | null>) { state.detail = action.payload; },
    upsertDepartment(state, action: PayloadAction<Department>) {
      const index = state.items.findIndex((item) => item.id === action.payload.id);
      if (index === -1) state.items.push(action.payload);
      else state.items[index] = action.payload;
      state.detail = action.payload;
    },
    removeDepartment(state, action: PayloadAction<string>) {
      state.items = state.items.filter((item) => item.id !== action.payload);
      if (state.detail?.id === action.payload) state.detail = null;
    },
  },
});

export const { setDepartments, setDepartmentDetail, upsertDepartment, removeDepartment } = slice.actions;
export default slice.reducer;
